import { CreditCardOutlined } from '@ant-design/icons';
import { lazyRouteComponent } from '@tanstack/react-router';

import { ACCOUNT_ROLE_CODES } from '@lib/types';
import { Route } from '@lib/types/route';

import { ROUTE_PATHS } from '../route-paths';

const PaymentSettingsPage = lazyRouteComponent(
  () => import('./pages/settings'),
);

export const getRoutes = (): Route[] => [
  {
    page: PaymentSettingsPage,
    path: ROUTE_PATHS.ADMIN_PAYMENTS,
    title: 'Pagamentos',
    icon: CreditCardOutlined,
    acl: [ACCOUNT_ROLE_CODES.ADMIN],
    adminSection: 'finance',
    adminOrder: 30,
  },
];
